
<template>
  <div class="change-account">
    <div class="commonBg"></div>
    <div class="uploadPage_toptitle">
      <div class="uploadPage_toptitlebox">
        <van-icon name="arrow-left" @click="back" />
        <div class="details_top_title">绑定游戏信息</div>
        <span></span>
        <!-- <van-icon name="close" /> -->
      </div>
    </div>
    <div class="container">
      <div class="choose-account" v-if="pageIndex == 1">
        <span class="tip1">检测到绑定码关联的社区账号 </span>
        <div class="current-account">
          <img
            class="avatar"
            :src="
              accountArr[0].current == 1
                ? accountArr[1].avatar
                : accountArr[0].avatar
            "
          />
          <span class="name">{{
            accountArr[0].current == 1
              ? accountArr[1].nickName
              : accountArr[0].nickName
          }}</span>
        </div>
        <span class="tip2">请选择要保留的账号(二选一) </span>
        <div
          class="account-box"
          v-for="item in accountArr"
          :key="item.id"
          @click="chooseAcc(item)"
        >
          <i class="select-on" v-if="currentAcc.memberId == item.memberId"></i>
          <img class="avatar" :src="item.avatar" />
          <div class="info">
            <span class="name">{{ item.nickName }}</span>
            <span class="info-text info1">{{ item.remark }}</span>
            <!-- <span class="info-text info2">dasda</span> -->
          </div>
          <i class="current-icon" v-if="item.current == 1"></i>
        </div>
        <i class="change-btn" @click="changePop">换绑</i>
        <i class="no-change" @click="noChange">暂不换绑</i>
      </div>
      <div class="change-success" v-if="pageIndex == 2">
        <span class="tip1"
          >已经成功将当前登录社区账号绑定至&nbsp;{{
            currentAcc.nickName
          }}&nbsp;社区账号
        </span>
        <div class="account-box">
          <img class="avatar" :src="currentAcc.avatar" />
          <div class="info">
            <span class="name">{{ currentAcc.nickName }}</span>
            <span class="info-text info1">{{ currentAcc.remark }}</span>
          </div>
        </div>
        <i class="return-btn" @click="closeChangeBind">返回</i>
      </div>
      <div class="game-code" v-if="pageIndex == 0">
        <span class="tip">请输入绑定码，获取游戏信息</span>
        <div class="tip2" @click="getCodeShow = true">
          <span>请打开游戏App-社区-我的-绑定码 获取 </span>
          <i class="help-icon"></i>
        </div>
        <input type="text" v-model="bindNum" placeholder="输入绑定码" />
        <i class="submit" @click="bindQuery">确定</i>
      </div>
      <div class="pop" v-if="popShow">
        <div class="change-confirm">
          <span class="title">请确认换绑操作 </span>
          <span
            >将账号绑定至{{ currentAcc.nickName }}账号后，社区账号{{
              currentAcc.memberId == accountArr[0].memberId
                ? accountArr[1].nickName
                : accountArr[0].nickName
            }}将无法登录。社区账号互相绑定不影响游戏账号。请输入“我确认不再需要登录此社区账号”进行换绑。
          </span>
          <input
            type="text"
            v-model="confirmText"
            placeholder="我确认不再需要登录此社区账号"
          />
          <div class="btn-box">
            <i @click="popShow = false">取消</i>
            <i @click="changeBind">确认</i>
          </div>
        </div>
      </div>
    </div>
    <getBindCode v-if="getCodeShow"></getBindCode>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { Toast } from 'vant';
import * as _code from '../../../../../src/utils/code';
import getBindCode from '../../../login/getBindCode.vue';
import get from '@/api/get';
import qs from 'qs';
export default {
  components: {
    getBindCode
  },
  data() {
    return {
      getCodeShow: false,
      confirmText: '',
      popShow: false,
      currentAcc: {},
      pageIndex: 0,
      bindNum: '',
      accountArr: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    closeChangeBind() {
      this.$router.push({ name: 'homePage' });
      setTimeout(() => {
        location.reload(); //刷新token信息
      }, 100);
    },
    changeBind() {
      if (this.confirmText == '我确认不再需要登录此社区账号') {
        let params = {
          bindCode: this.bindNum,
          memberId: this.currentAcc.memberId,
          secdat: this.currentAcc.secdat
        };
        get.bindCode(qs.stringify(params)).then((res) => {
          if (res.data.message == 'success') {
            this.pageIndex = 2;
            this.popShow = false;
            //换token、memberId
            let objToken = JSON.parse(sessionStorage.getItem('userObj'));
            objToken.token = res.data.data[0].token;
            // objToken.memberId = this.currentAcc.memberId;
            sessionStorage.setItem('userObj', JSON.stringify(objToken));
            this.$store.commit(
              'setUserInfo',
              JSON.parse(sessionStorage.getItem('userObj'))
            );
            let cook_auth = `_pd_auth_${
              this.$store.state.gameAppkeyArr[this.$store.state.gameType]
            }`;
            this.$store.commit('changeToken', Cookies.get(cook_auth));
            this.$store.commit('changeBindCodeShow', false);
            // localStorage.setItem('bindCodeShow', false);
          }
        });
      } else {
        Toast('请输入正确验证文案');
      }
    },
    changePop() {
      if (this.currentAcc.memberId) {
        this.popShow = true;
      } else {
        Toast('请选择一个账号');
      }
    },
    chooseAcc(item) {
      this.currentAcc = item;
    },
    noChange() {
      this.bindNum = '';
      this.pageIndex = 0;
    },
    bindQuery() {
      if (this.bindNum != '') {
        get
          .bindCodeQuery(qs.stringify({ bindCode: this.bindNum }))
          .then((res) => {
            console.log(res.data);
            // if (res.data.code == 2055) {
            //   Toast('绑定码错误');
            // } else if (res.data.code == 2056) {
            //   Toast('绑定码已被绑定');
            // } else
            if (res.data.code != 0) {
              this.errorMessage(res.data);
            } else {
              this.$set(this.accountArr, 0, res.data.data[0]);
              this.$set(this.accountArr, 1, res.data.data[1]);
              this.pageIndex = 1;
            }
          });
      } else {
        Toast('请输入绑定码');
      }
    },
    back() {
      this.$emit('changePage', 0);
    },
    //错误提示
    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='scss' scoped>
.change-account {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  .container {
    i {
      display: block;
      font-style: normal;
    }
    margin-top: 1.5rem;
    width: 100%;
    height: 100%;
    background-color: #fff;
    padding: 0 0.6rem;
    box-sizing: border-box;
    .choose-account {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 0.22rem;
        color: #000;
      }
      .tip1 {
        margin-top: 0.58rem;
        margin-bottom: 0.25rem;
      }
      .current-account {
        width: 4.06rem;
        height: 1.3rem;
        background: #ffffff;
        border: 0.01rem solid #e6e6e6;
        box-shadow: 0rem 0.08rem 0.13rem 0rem rgba(34, 49, 60, 0.07);
        display: flex;
        align-items: center;
        .avatar {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin: 0 0.3rem;
        }
      }
      .tip2 {
        margin-top: 0.99rem;
        margin-bottom: 0.34rem;
      }
      .account-box-on {
        border: 1px solid #23303b;
      }
      .account-box:nth-child(4) {
        margin-bottom: 0.32rem;
      }
      .account-box {
        width: 5.74rem;
        height: 1.3rem;
        background: #ffffff;
        border: 0.01rem solid #e6e6e6;
        display: flex;
        align-items: center;
        position: relative;
        .current-icon {
          width: 0.67rem;
          height: 0.22rem;
          background: url('../../../../assets/img/gl/current-account.png');
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          right: 0;
        }
        .select-on {
          width: 0.24rem;
          height: 0.24rem;
          background: url('../../../../assets/img/gl/select-on.png');
          background-size: 100% 100%;
          // transform: translateX(-0.54rem);
          position: absolute;
          left: -0.54rem;
        }
        .avatar {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin: 0 0.3rem;
        }
        .info {
          display: flex;
          flex-direction: column;
          .info-text {
            line-height: 0.16rem;
            font-size: 0.18rem;
            color: #969696;
            margin-top: 0.16rem;
          }
        }
      }
      .change-btn {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
        margin-top: 1rem;
        margin-bottom: 0.4rem;
      }
      .no-change {
        width: 6.29rem;
        height: 0.72rem;
        background: #f5f5f5;
        color: #898989;
        font-size: 0.32rem;
        text-align: center;
        line-height: 0.72rem;
      }
    }
    .change-success {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .tip1 {
        margin-top: 0.6rem;
        margin-bottom: 0.4rem;
      }
      span {
        font-size: 0.22rem;
        color: #000;
      }
      .account-box {
        width: 5.74rem;
        height: 1.3rem;
        background: #ffffff;
        border: 0.01rem solid #e6e6e6;
        display: flex;
        align-items: center;
        position: relative;
        .avatar {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin: 0 0.3rem;
        }
        .info {
          display: flex;
          flex-direction: column;
          .info-text {
            line-height: 0.16rem;
            font-size: 0.18rem;
            color: #969696;
            margin-top: 0.16rem;
          }
        }
      }
      .return-btn {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
        margin-top: 0.5rem;
      }
    }
    .no-account {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .tip1 {
        font-size: 0.24rem;
        color: #000;
      }
      .tip2 {
        font-size: 0.22rem;
        color: #000;
        margin-top: 1.54rem;
        margin-bottom: 0.3rem;
      }
      .no-icon {
        width: 0.9rem;
        height: 0.9rem;
        background: url('../../../../assets/img/gl/no-account.png');
        background-size: 100% 100%;
        margin-top: 1.19rem;
        margin-bottom: 0.54rem;
      }
      .account-box {
        width: 5.74rem;
        height: 1.3rem;
        background: #ffffff;
        border: 0.01rem solid #e6e6e6;
        display: flex;
        align-items: center;
        position: relative;
        .current-icon {
          width: 0.67rem;
          height: 0.22rem;
          background: url('../../../../assets/img/gl/current-account.png');
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          right: 0;
        }
        .avatar {
          width: 1rem;
          height: 1rem;
          border-radius: 50%;
          margin: 0 0.3rem;
        }
        .info {
          display: flex;
          flex-direction: column;
          .info-text {
            line-height: 0.16rem;
            font-size: 0.18rem;
            color: #969696;
            margin-top: 0.16rem;
          }
        }
      }
      .change-btn {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
        margin-top: 0.51rem;
        margin-bottom: 0.4rem;
      }
      .no-change {
        width: 6.29rem;
        height: 0.72rem;
        background: #f5f5f5;
        color: #898989;
        font-size: 0.32rem;
        text-align: center;
        line-height: 0.72rem;
      }
    }
    .game-code {
      width: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .tip {
        font-size: 0.32rem;
        color: #2b2b2b;
        margin-top: 0.67rem;
        margin-bottom: 0.28rem;
      }
      .tip2 {
        width: 100%;
        display: flex;
        align-items: center;
        span {
          font-size: 0.24rem;
          color: #969696;
          margin-right: 0.09rem;
        }
        .help-icon {
          width: 0.22rem;
          height: 0.22rem;
          background: url('../../../../assets/img/gl/help-icon.png');
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
      input {
        margin-top: 0.3rem;
        margin-bottom: 0.46rem;
        width: 6.29rem;
        height: 0.4rem;
        border: none;
        outline: none;
        border-bottom: 0.01rem solid #ebebeb;
      }
      *::-webkit-input-placeholder {
        color: #cccccc;
      }

      *:-moz-placeholder {
        /* FF 4-18 */
        color: #cccccc;
      }

      *::-moz-placeholder {
        /* FF 19+ */
        color: #cccccc;
      }

      *:-ms-input-placeholder {
        /* IE 10+ */
        color: #cccccc;
      }
      .submit {
        width: 6.29rem;
        height: 0.72rem;
        background: #23323d;
        text-align: center;
        line-height: 0.72rem;
        font-size: 0.32rem;
        color: #fff;
      }
    }
    .pop {
      width: 100%;
      height: 100vh;
      background-color: rgba(0, 0, 0, 0.8);
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
      display: flex;
      justify-content: center;
      align-items: center;
      .change-confirm {
        width: 5rem;
        height: 4.15rem;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 0 0.35rem;
        box-sizing: border-box;
        position: relative;
        .title {
          color: #2b2b2b;
          font-size: 0.3rem;
          font-weight: 500;
          margin-top: 0.3rem;
          margin-bottom: 0.16rem;
        }
        span {
          color: #1a1a1a;
          font-size: 0.22rem;
        }
        input {
          margin-top: 0.2rem;
          width: 4.38rem;
          height: 0.72rem;
          font-size: 0.24rem;
          outline: none;
          border: 0.01rem solid #b3b3b3;
          padding-left: 0.1rem;
          box-sizing: border-box;
        }
        *::-webkit-input-placeholder {
          color: #cccccc;
        }

        *:-moz-placeholder {
          /* FF 4-18 */
          color: #cccccc;
        }

        *::-moz-placeholder {
          /* FF 19+ */
          color: #cccccc;
        }

        *:-ms-input-placeholder {
          /* IE 10+ */
          color: #cccccc;
        }
        .btn-box {
          width: 100%;
          height: 0.76rem;
          position: absolute;
          bottom: 0;
          border-top: 0.01rem solid #b3b3b3;
          display: flex;
          i {
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          i:nth-child(1) {
            border-right: 0.01rem solid #b3b3b3;
          }
          i:active {
            background-color: #cccccc;
          }
        }
      }
    }
  }
}
</style>